import { memo } from "react";

import { BlueprintDeployment } from "types/generated";
import { SortStateDescriptor } from "components/Filters/types";
import TableSimple from "ds/components/TableSimple";

import useTemplateDeploymentsTableStore from "./useTemplateDeploymentsTableStore";
import { FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { TEMPLATE_DEPLOYMENTS_TABLE_CELLS } from "./Cells";
import { TEMPLATE_DEPLOYMENTS_SORT_CONFIG } from "./constants";

type DeploymentsTableProps = {
  deployments: BlueprintDeployment[];
  loading?: boolean;
  rowsPerPage: number;
  sortCallback: (sortDescriptor: SortStateDescriptor) => void;
};

const DeploymentsTable = ({
  deployments,
  loading,
  rowsPerPage,
  sortCallback,
}: DeploymentsTableProps) => {
  return (
    <TableSimple
      data={deployments}
      loading={loading}
      store={useTemplateDeploymentsTableStore}
      ariaLabel="Deployments table"
      rowsPerPage={rowsPerPage}
      sortCallback={sortCallback}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      cellPerColumn={TEMPLATE_DEPLOYMENTS_TABLE_CELLS}
      sortConfig={TEMPLATE_DEPLOYMENTS_SORT_CONFIG}
    />
  );
};

export default memo(DeploymentsTable);
